export default class Process {
  id = null;
  name = "";
  description = "";
  processSteps = [];
  role = null;
  startBuffer = null;
  endBuffer = null;
  repeatEveryDays = null;
  repeatEveryMonthOnDay = null;
  validFrom = null;
  validUntil = null;
  updateable = null;
  addOldResult = null;

  constructor() {
  }
}
